import simg1 from "../images/services/icon-1.svg";
import simg2 from "../images/services/icon-2.svg";
import simg3 from "../images/services/icon-3.svg";
import simg4 from "../images/services/icon-4.svg";

import sSimg1 from "../images/service-single/1.webp";
import sSimg2 from "../images/service-single/2.webp";
import sSimg3 from "../images/service-single/3.webp";
import sSimg4 from "../images/service-single/4.webp";

const Services = [
  {
    Id: "01",
    sImg: simg1,
    sSImg: sSimg1,
    title: "Empower 1M Business Owners",
    slug: "1",
    description:
      "Equip one million entrepreneurs with advanced cash flow strategies to achieve sustainable business growth.",
  },
  {
    Id: "02",
    sImg: simg2,
    sSImg: sSimg2,
    title: "Enable Investor Partnerships",
    slug: "2",
    description:
      "Create a platform for direct investor-business partnerships to fuel growth and innovation.",
  },
  {
    Id: "03",
    sImg: simg3,
    sSImg: sSimg3,
    title: "Showcase Scalable Models",
    slug: "3",
    description:
      "Highlight proven business models that demonstrate exceptional cash flow management principles.",
  },
  {
    Id: "04",
    sImg: simg4,
    sSImg: sSimg4,
    title: "Position India as Cash Flow Hub",
    slug: "4",
    description:
      "Establish India as a global leader in cash flow innovation and financial strategy development.",
  },
];

export default Services;
